export const BOOKING_DETAIL_POLLING_INTERVAL = 1000
export const BOOKING_DETAIL_POLLING_MAX_COUNT = 5

export type PollBookingQueryArgs = {
  pollCount: number
}

// This function determines the polling interval, if we should poll and if we should stop polling
// We only stop polling when we are absolutely sure that we shouldn't poll anymore
export const pollBookingQuery = ({ pollCount }: PollBookingQueryArgs): false | number => {
  const poll = (): number => {
    return BOOKING_DETAIL_POLLING_INTERVAL
  }

  const stopPolling = (): false => {
    return false
  }

  const shouldPoll = pollCount < BOOKING_DETAIL_POLLING_MAX_COUNT

  // We should always return true unless we are absolutely sure that we shouldn't
  if (shouldPoll) {
    // When the booking is updated after the polling is complete, we would land here
    // So we should reset the polling state to true
    return poll()
  } else {
    return stopPolling()
  }
}
